import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../button';
import UndrawEverywhere from '../../undraw-illustrations/undraw-everywhere';
import UndrawBrowser from '../../undraw-illustrations/undraw-browser';
import {UndrawCalendar, UndrawExperts, UndrawHouseSearching} from 'react-undraw-illustrations';
import {Link} from 'react-router-dom'


import '../content-section.css';
const color="#07A4B5"

const SectionTwo = ({authenticated, signOut}) => (
<div>
<div className="expanded landing__section">
			<div className="container">
				<div className="expanded__inner">
					<div className="expanded__image" style={{'margin':'0 auto'}}>
						<UndrawExperts 
							primaryColor={color}
							height='250px'
							accentColor='#C9EFF9'/>
					</div>
					<div className="expanded__content">
						<h2 style={{fontWeight:'600', color:'#555', marginTop:0}} className="expanded__title">Invite only 🐨</h2>
						{/* <img src="https://s3.amazonaws.com/colivingly/profile-image/hi.png" style={{borderRadius:'10px', width:'90%', marginBottom:'10px'}}/>					 */}

						<p style={{fontSize:'16px'}}className="expanded__text">Answer some questions from Coliving Koala. Once you're verified, you will get access to the Coliving List, where you can meet other verified makers who want to move to the same place as you, in a similar timeframe.</p>
						<Link to="/join">
						<button
								className="button "
								size="large">
								Answer some questions
							</button>
							</Link>
					</div>
				</div>
			</div>
		</div>
	<div className="expanded landing__section">
			<div className="container">
				<div className="expanded__inner">
					<div className="expanded__media">
						<div className="expanded__image" style={{'margin':'0 auto'}}>
							<UndrawHouseSearching
							primaryColor='#C9EFF9'
							accentColor={color}
							height="190px"
							/>
						</div>
					</div>
					<div className="expanded__content">
						<h2 className="expanded__title" style={{fontWeight:'600', color:'#555', marginTop:0}}>Find the right people and place 🌴</h2>
						<p style={{fontSize:'18px'}}className="expanded__text">Access a list of makers who've already answered our questions. <a style={{color:'#34d1e2'}}target="_blank" href="https://www.airbnb.co.uk/help/article/2034/what-s-group-payment">Group book</a> with people who match with you.</p>
						<Link to="join">
							<button
								className="button"
								onClick={this.handleSubmit}
								size="large">
								Take the questionnaire
							</button>
						</Link>
					</div>
				</div>
			</div>
		</div>
		<div className="expanded landing__section">
			<div className="container">
				<div className="expanded__inner">
					<div className="expanded__media">
						<div className="expanded__image" style={{'margin':'0 auto'}}>
							<UndrawCalendar 
								primaryColor='#C9EFF9'
								accentColor='#FED8A7'
								height='250px'
							/>
						</div>
					</div>
					<div className="expanded__content">
						<h2 className="expanded__title" style={{fontWeight:'600', color:'#555', marginTop:0}}>Plan and schedule together 🗺</h2>
						<p style={{fontSize:'18px'}}className="expanded__text">Match with listed makers who want to go to the same region at the same time as you. No more asking in forums.</p>
							{/* <Link to="/join">
							<button
								className="button "
								// onClick={this.handleSubmit}
								size="large">
								How it works
							</button>
							</Link> */}
					</div>
				</div>
			</div>
		</div>
	</div>
);


export default SectionTwo;



// WEBPACK FOOTER //
// ./src/views/components/content-section/templates/section-two.js